import SessionEventProto from "../session-event-proto"
import ActionEntity from "../../model2/automation/action-entity/action-entity"
import {EVENT_BUS_SESSION_ACTIONS_CHANGED} from "./@const"


export default class SessionEvent_ActionReset extends SessionEventProto {

    constructor(sessionEvent: any) {
        super(sessionEvent)
    }

    process() {
        const models = _.map(this.data, (record: JSONObject) => new ActionEntity(record))
        gd.session.actions.reset(models)
        gd.bus.triggerEvent(EVENT_BUS_SESSION_ACTIONS_CHANGED)
    }
}
